import PropTypes from 'prop-types'
import {Form} from 'formik'
import {Flex, Text, Button} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

import FormField from '~/react/components/FormField'

const BusinessInformationStep = ({isValid, isSubmitting, onNext, onCancel}) => {
  const {t} = useTranslation('points')

  return (
    <Form>
      <Flex direction="column" gap="md">
        <Text textStyle="body-small" color="gray.600">
          {t('points:connectionDrawer.steps.businessInfo.description')}
        </Text>

        <FormField
          type="text"
          name="businessNumber"
          label={t('points:connectionDrawer.fields.businessNumber.label')}
          placeholder={t(
            'points:connectionDrawer.fields.businessNumber.placeholder',
          )}
        />

        <FormField
          type="text"
          name="street"
          label={t('points:connectionDrawer.fields.street.label')}
          placeholder={t('points:connectionDrawer.fields.street.placeholder')}
        />

        <FormField
          type="text"
          name="city"
          label={t('points:connectionDrawer.fields.city.label')}
          placeholder={t('points:connectionDrawer.fields.city.placeholder')}
        />

        <FormField
          type="text"
          name="stateCode"
          label={t('points:connectionDrawer.fields.stateCode.label')}
          placeholder={t(
            'points:connectionDrawer.fields.stateCode.placeholder',
          )}
        />

        <FormField
          type="text"
          name="postalCode"
          label={t('points:connectionDrawer.fields.postalCode.label')}
          placeholder={t(
            'points:connectionDrawer.fields.postalCode.placeholder',
          )}
        />

        <Flex justify="space-between" mt="md">
          <Button variant="primary" onClick={onCancel}>
            {t('points:connectionDrawer.buttons.cancel')}
          </Button>
          <Button
            variant="primary"
            colorScheme="primary"
            onClick={onNext}
            isDisabled={!isValid || isSubmitting}
            isLoading={isSubmitting}
          >
            {t('points:connectionDrawer.buttons.next')}
          </Button>
        </Flex>
      </Flex>
    </Form>
  )
}

BusinessInformationStep.propTypes = {
  isValid: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onNext: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}

export default BusinessInformationStep
